module.exports = __webpack_public_path__ + "img/img-flow-4.00e52d68.jpg";